import React, { Component } from 'react';
import DeleteAlertCompoment from '../core/DeleteAlertComponent';
import UploadFileAlertComponent from '../core/UploadFileAlertComponent';
import Form from 'react-bootstrap/Form';
import Alert from 'react-bootstrap/Alert';
import CurrentUser from '../../public/core/PublicUserSessionContext';
import firebase from 'firebase';
import { deleteProcedure, getProcedure, getTags, saveProcedureData, uploadDemo, uploadFasicle, uploadPreview, uploadVideo, uploadTranslationDemo, uploadTranslationVideo, uploadTranslationFasicle } from '../../../service/procedures';
import { listProcedureTranslations, saveProcedureTranslation, deleteProcedureTranslation } from '../../../service/procedureTranslations';
import { addFileToTmp, removeTmpForProcedure } from '../../../service/storage';
import {
    SPECIES_TYPES, REQUIRED_INPUT_MESSAGE, VALID_FORMAT_MESSAGE, CXVET_VIDEO_TYPES,
    ACCEPTED_IMAGES, REQUIRED_SELECT_MESSAGE, GRATIS,
    DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES, LANGUAGE_NAMES
} from '../../../service/constants';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import Select from 'react-select';
import MediaUpload from './MediaUpload';
import {
    TitleDescriptionSection,
    GuideSection,
    StatusSection,
    VideosSection,
    MarkersSection
} from './TranslationContent';

class ProcedureFormComponent extends Component {
    constructor(props) {
        super(props);
        const editing = this.props.match.params.id ? true : false;
        const procedureID = editing 
            ? this.props.match.params.id 
            : firebase.firestore().collection("procedures").doc().id;
        
        this.state = {
            procedureID,
            editing,
            procedure: {
                name: "",
                type: GRATIS,
                kynd: "",
                date: Date.now(),
                times: [],
                tags: {},
                meta: "",
                demo: "",
                fascicle: "",
                preview: "",
                video: "",
                translationLanguages: [DEFAULT_LANGUAGE],
            },
            tags: [],
            errors: {},
            translationLanguages: [DEFAULT_LANGUAGE],
            translationsByLang: {},
            activeLanguage: DEFAULT_LANGUAGE,
            translationFiles: {},
            removedTranslationLanguages: [],
            fileStatus: { name: "", state: 0 },
            deleteModalShow: false,
            fileModalShow: false,
            uploadingFiles: {},
        };
    }

    sortLanguagesByOrder = (languages) => {
        const languageOrder = SUPPORTED_LANGUAGES
        return languages.sort((a, b) => {
            const indexA = languageOrder.indexOf(a)
            const indexB = languageOrder.indexOf(b)
            if (indexA === -1 && indexB === -1) return 0
            if (indexA === -1) return 1
            if (indexB === -1) return -1
            return indexA - indexB
        })
    }

    componentDidMount = () => {
        this.getInitialData()
    }
    getInitialData = async () => {
        this.context.iniciaCarga()
        let { procedureID, editing, procedure } = this.state
        let tags = await getTags()
        procedure = editing ? await getProcedure(procedureID) : procedure
        
        let translationsByLang = {}
        let translationLanguages = procedure.translationLanguages || [DEFAULT_LANGUAGE]
        
        if (editing && procedureID) {
            translationsByLang = await listProcedureTranslations(procedureID)
            const existingLangs = Object.keys(translationsByLang)
            if (existingLangs.length > 0) {
                translationLanguages = [DEFAULT_LANGUAGE, ...existingLangs]
                
                existingLangs.forEach(lang => {
                    if (translationsByLang[lang] && procedure.times) {
                        if (!translationsByLang[lang].times || translationsByLang[lang].times.length !== procedure.times.length) {
                            translationsByLang[lang].times = procedure.times.map(t => {
                                const translatedTime = translationsByLang[lang].times?.find(tt => tt.time === t.time)
                                return {
                                    time: t.time,
                                    name: translatedTime?.name || t.name || ""
                                }
                            })
                        } else {
                            translationsByLang[lang].times = procedure.times.map((baseTime, idx) => {
                                const existingTranslation = translationsByLang[lang].times[idx]
                                return {
                                    time: baseTime.time,
                                    name: existingTranslation && existingTranslation.time === baseTime.time ? existingTranslation.name : (baseTime.name || "")
                                }
                            })
                        }
                    }
                })
            }
        }
        
        if (!procedure.translationLanguages) {
            procedure.translationLanguages = translationLanguages
        }
        
        translationLanguages = this.sortLanguagesByOrder(translationLanguages)
        
        this.setState({ 
            procedure, 
            tags, 
            translationsByLang, 
            translationLanguages,
            activeLanguage: DEFAULT_LANGUAGE
        });
        this.context.terminaCarga()
    }

    handleFormSubmit = async (event) => {
        event.preventDefault();
        
        const { uploadingFiles } = this.state
        const hasUploadingFiles = Object.keys(uploadingFiles).length > 0
        
        if (hasUploadingFiles) {
            const errors = { ...this.state.errors }
            errors._general = "Por favor espera a que terminen de subirse todos los archivos antes de guardar."
            this.setState({ errors })
            return
        }
        
        if (this.validateErrors()) {
            this.context.iniciaCarga()
            const { procedureID, procedure, translationLanguages, translationsByLang } = this.state

            const data = { 
                ...procedure, 
                demo: procedure.demo, 
                fascicle: procedure.fascicle, 
                preview: procedure.preview, 
                video: procedure.video, 
                translationLanguages 
            }
            
            try {
                await saveProcedureData(procedureID, data)

                for (const lang of translationLanguages) {
                    if (lang === DEFAULT_LANGUAGE) continue
                    
                    const translation = translationsByLang[lang]
                    if (!translation) continue
                    
                    let translationData = { ...translation }
                    
                    if (translation.times && this.state.procedure.times) {
                        translationData.times = this.state.procedure.times.map((baseTime, idx) => {
                            const translatedTime = translation.times.find(t => t.time === baseTime.time) || translation.times[idx]
                            return {
                                time: baseTime.time,
                                name: translatedTime ? translatedTime.name : ""
                            }
                        })
                    }
                    
                    await saveProcedureTranslation(procedureID, lang, translationData)
                }
                
                for (const lang of this.state.removedTranslationLanguages) {
                    try {
                        await deleteProcedureTranslation(procedureID, lang)
                    } catch (error) {
                        console.error(`Error al eliminar traducción ${lang}:`, error)
                    }
                }
                
                try {
                    await removeTmpForProcedure(procedureID)
                } catch (error) {
                    console.error(`Error al limpiar archivos temporales:`, error)
                }
                
                this.context.terminaCarga()
                this.props.history.push("/admin/procedures")
            } catch (error) {
                console.error('Error al guardar procedimiento:', error)
                this.context.terminaCarga()
                const errors = { ...this.state.errors }
                errors._general = "Error al guardar el procedimiento. Por favor, intenta nuevamente."
                this.setState({ errors })
            }
        }
    }
    validateErrors = () => {
        let errors = {}, timeErrors = {};
        const required = ["name", "detail", "kynd", "demo", "fascicle", "preview", "video"]

        const isBlobUrl = (url) => url && url.startsWith('blob:')

        required.forEach(field => {
            if (field === "kynd" && !this.state.procedure.kynd)
                errors.kynd = REQUIRED_SELECT_MESSAGE
            else if (!this.state.procedure[field])
                errors[field] = REQUIRED_INPUT_MESSAGE
            else if (isBlobUrl(this.state.procedure[field])) {
                errors[field] = "El archivo aún se está subiendo. Por favor espera."
            }
        })

        this.state.procedure.times.forEach((time, index) => {
            if (!time.name)
                timeErrors[`name_${index}`] = REQUIRED_INPUT_MESSAGE
            if (!time.time)
                timeErrors[`time_${index}`] = REQUIRED_INPUT_MESSAGE
            else {
                var regex = /^([0-9])(:)([0-6][0-9])(:)([0-5][0-9])$/;
                if (!regex.test(time.time))
                    timeErrors[`time_${index}`] = VALID_FORMAT_MESSAGE;
            }
        });
        if (Object.keys(timeErrors).length > 0)
            errors.timeErrors = timeErrors

        const { translationsByLang, translationLanguages, removedTranslationLanguages } = this.state
        let firstTranslationWithErrors = null
        translationLanguages.forEach(lang => {
            if (lang === DEFAULT_LANGUAGE) return
            if (removedTranslationLanguages.includes(lang)) return
            const translation = translationsByLang[lang]
            if (translation && translation.enabled) {
                const translationErrors = {}
                if (!translation.name) translationErrors.name = REQUIRED_INPUT_MESSAGE
                if (!translation.detail) translationErrors.detail = REQUIRED_INPUT_MESSAGE
                if (!translation.demo) translationErrors.demo = "Debes subir un video demo para esta traducción."
                else if (isBlobUrl(translation.demo)) translationErrors.demo = "El archivo aún se está subiendo. Por favor espera."
                if (!translation.video) translationErrors.video = "Debes subir un video para esta traducción."
                else if (isBlobUrl(translation.video)) translationErrors.video = "El archivo aún se está subiendo. Por favor espera."
                if (!translation.fascicle) translationErrors.fascicle = "Debes subir una guía para esta traducción."
                else if (isBlobUrl(translation.fascicle)) translationErrors.fascicle = "El archivo aún se está subiendo. Por favor espera."
                
                if (translation.times) {
                    translation.times.forEach((time, index) => {
                        if (!time.name) {
                            if (!translationErrors.timeErrors) translationErrors.timeErrors = {}
                            translationErrors.timeErrors[`name_${index}`] = REQUIRED_INPUT_MESSAGE
                        }
                    })
                }
                
                if (Object.keys(translationErrors).length > 0) {
                    errors[`translation_${lang}`] = translationErrors
                    if (!firstTranslationWithErrors) {
                        firstTranslationWithErrors = lang
                    }
                }
            }
        })

        const baseErrors = Object.keys(errors).filter(key => !key.startsWith('translation_'))
        const hasBaseErrors = baseErrors.length > 0
        
        const stateUpdate = { errors }
        if (hasBaseErrors) {
            stateUpdate.activeLanguage = DEFAULT_LANGUAGE
        } else if (firstTranslationWithErrors) {
            stateUpdate.activeLanguage = firstTranslationWithErrors
        }
        this.setState(stateUpdate)
        return Object.keys(errors).length === 0
    }

    handleInputChange = (event) => {
        let { name, value, type, checked } = event.target

        const procedure = { ...this.state.procedure };
        const { [name]: tagName, ...restOfTags } = procedure.tags

        if (type === "checkbox")
            procedure.tags = checked ? { ...restOfTags, [name]: checked } : restOfTags
        else
            procedure[name] = value
        this.setState({ procedure, errors: {} });
    }
    handleFileChange = async (event) => {
        const file = event.target.files[0]
        if (!file) return
        
        const name = event.target.name
        const fileType = `${name}File`
        const { procedureID } = this.state
        
        const previewUrl = URL.createObjectURL(file)
        const procedure = { ...this.state.procedure, [name]: previewUrl }
        const uploadingFiles = { ...this.state.uploadingFiles, [name]: true }
        const errors = { ...this.state.errors }
        delete errors[name]
        
        this.setState({ procedure, [fileType]: file, uploadingFiles, errors })
        
        try {
            let uploadFn, fileTypeForTmp
            
            switch(name) {
                case 'demo':
                    uploadFn = uploadDemo
                    fileTypeForTmp = 'video_demo_files'
                    break
                case 'fascicle':
                    uploadFn = uploadFasicle
                    fileTypeForTmp = 'guide_files'
                    break
                case 'preview':
                    uploadFn = uploadPreview
                    fileTypeForTmp = 'image_preview_files'
                    break
                case 'video':
                    uploadFn = uploadVideo
                    fileTypeForTmp = 'video_files'
                    break
                default:
                    return
            }
            
            const uploadResult = await uploadFn(procedureID, file, (data) => this.setState(data))
            const downloadUrl = uploadResult.url || uploadResult
            const storagePath = uploadResult.storagePath || `procedures/${procedureID}/${file.name}`
            const fileName = storagePath.split('/').pop()
            
            const fileInfo = {
                fileType: fileTypeForTmp,
                procedureId: procedureID,
                lang: null,
                storagePath,
                downloadUrl,
                fileName
            }
            
            await addFileToTmp(fileInfo)
            
            const updatedProcedure = { ...this.state.procedure, [name]: downloadUrl }
            const updatedUploadingFiles = { ...this.state.uploadingFiles }
            delete updatedUploadingFiles[name]
            
            this.setState({ 
                procedure: updatedProcedure, 
                uploadingFiles: updatedUploadingFiles
            })
        } catch (error) {
            console.error(`Error al subir ${name}:`, error)
            const errorMessage = `Error al subir el archivo. Por favor, intenta nuevamente.`
            const updatedErrors = { ...this.state.errors, [name]: errorMessage }
            const updatedUploadingFiles = { ...this.state.uploadingFiles }
            delete updatedUploadingFiles[name]
            this.setState({ errors: updatedErrors, uploadingFiles: updatedUploadingFiles })
        }
    }
    
    handleBaseFileChange = (event) => {
        this.handleFileChange(event)
    }
    handleTimeChange = (event) => {
        const { name, value, id, index = id } = event.target
        let procedure = { ...this.state.procedure }
        const oldTime = procedure.times[index].time
        procedure.times[index][name] = value;
        
        const translationsByLang = { ...this.state.translationsByLang }
        if (name === "time" && oldTime !== value) {
            Object.keys(translationsByLang).forEach(lang => {
                if (translationsByLang[lang].times) {
                    const translationTime = translationsByLang[lang].times.find(t => t.time === oldTime)
                    if (translationTime) {
                        translationTime.time = value
                    } else if (translationsByLang[lang].times[index]) {
                        translationsByLang[lang].times[index].time = value
                    }
                }
            })
        }
        
        this.setState({ procedure, translationsByLang, errors: {} });
    }

    addTime = () => {
        const procedure = { ...this.state.procedure };
        procedure.times.push({ "name": "", "time": "" });
        procedure.timeName = "";
        procedure.time = "";
        
        const translationsByLang = { ...this.state.translationsByLang }
        Object.keys(translationsByLang).forEach(lang => {
            if (!translationsByLang[lang].times) {
                translationsByLang[lang].times = []
            }
            translationsByLang[lang].times.push({ "name": "", "time": "" })
        })
        
        this.setState({ procedure, translationsByLang });
    }
    deleteTime = (index) => {
        const procedure = { ...this.state.procedure };
        const deletedTime = procedure.times[index]
        procedure.times.splice(index, 1);
        
        const translationsByLang = { ...this.state.translationsByLang }
        Object.keys(translationsByLang).forEach(lang => {
            if (translationsByLang[lang].times) {
                const timeIndex = translationsByLang[lang].times.findIndex(t => t.time === deletedTime.time)
                if (timeIndex !== -1) {
                    translationsByLang[lang].times.splice(timeIndex, 1)
                } else {
                    translationsByLang[lang].times.splice(index, 1)
                }
            }
        })
        
        this.setState({ procedure, translationsByLang, errors: {} });
    }

    deleteProcedure = async () => {
        this.context.iniciaCarga()
        await deleteProcedure(this.state.procedureID)
        this.props.history.push("/admin/procedures")
        this.context.terminaCarga()
    }

    handleLanguageSelectorChange = (selectedOptions) => {
        const selectedLangs = selectedOptions ? selectedOptions.map(opt => opt.value) : [DEFAULT_LANGUAGE]
        if (!selectedLangs.includes(DEFAULT_LANGUAGE)) {
            selectedLangs.unshift(DEFAULT_LANGUAGE)
        }
        
        let activeLanguage = this.state.activeLanguage
        if (!selectedLangs.includes(activeLanguage)) {
            activeLanguage = DEFAULT_LANGUAGE
        }
        
        const translationsByLang = { ...this.state.translationsByLang }
        const removedLangs = this.state.translationLanguages.filter(lang => !selectedLangs.includes(lang) && lang !== DEFAULT_LANGUAGE)
        const addedLangs = selectedLangs.filter(lang => !this.state.translationLanguages.includes(lang) && lang !== DEFAULT_LANGUAGE)
        
        const removedTranslationLanguages = [...this.state.removedTranslationLanguages]
        removedLangs.forEach(lang => {
            if (!removedTranslationLanguages.includes(lang)) {
                removedTranslationLanguages.push(lang)
            }
        })
        
        const newRemovedTranslationLanguages = removedTranslationLanguages.filter(lang => !selectedLangs.includes(lang))
        
        addedLangs.forEach(lang => {
            if (!translationsByLang[lang]) {
                translationsByLang[lang] = {
                    enabled: true,
                    times: this.state.procedure.times && this.state.procedure.times.length > 0 
                        ? this.state.procedure.times.map(t => ({ time: t.time, name: t.name || "" }))
                        : []
                }
            }
        })
        
        const sortedSelectedLangs = this.sortLanguagesByOrder(selectedLangs)
        
        this.setState({ 
            translationLanguages: sortedSelectedLangs, 
            translationsByLang,
            removedTranslationLanguages: newRemovedTranslationLanguages,
            activeLanguage
        })
    }

    handleTranslationInputChange = (lang, field, value) => {
        const translationsByLang = { ...this.state.translationsByLang }
        if (!translationsByLang[lang]) {
            translationsByLang[lang] = { enabled: true }
        }
        translationsByLang[lang][field] = value
        this.setState({ translationsByLang })
    }

    handleTranslationFileChange = async (lang, fileType, event) => {
        const file = event.target.files[0]
        if (!file) return
        
        const { procedureID } = this.state
        const previewUrl = URL.createObjectURL(file)
        const translationsByLang = { ...this.state.translationsByLang }
        if (!translationsByLang[lang]) {
            translationsByLang[lang] = { enabled: true }
        }
        translationsByLang[lang][fileType] = previewUrl
        
        const translationFiles = { ...this.state.translationFiles }
        if (!translationFiles[lang]) {
            translationFiles[lang] = {}
        }
        translationFiles[lang][`${fileType}File`] = file
        
        const uploadKey = `translation_${lang}_${fileType}`
        const uploadingFiles = { ...this.state.uploadingFiles, [uploadKey]: true }
        const errors = { ...this.state.errors }
        const translationErrorKey = `translation_${lang}`
        if (errors[translationErrorKey]) {
            const translationErrors = { ...errors[translationErrorKey] }
            delete translationErrors[fileType]
            errors[translationErrorKey] = Object.keys(translationErrors).length > 0 ? translationErrors : undefined
        }
        
        this.setState({ translationsByLang, translationFiles, uploadingFiles, errors })
        
        try {
            let uploadFn, fileTypeForTmp
            
            switch(fileType) {
                case 'demo':
                    uploadFn = uploadTranslationDemo
                    fileTypeForTmp = 'video_demo_files'
                    break
                case 'fascicle':
                    uploadFn = uploadTranslationFasicle
                    fileTypeForTmp = 'guide_files'
                    break
                case 'video':
                    uploadFn = uploadTranslationVideo
                    fileTypeForTmp = 'video_files'
                    break
                default:
                    return
            }
            
            const uploadResult = await uploadFn(procedureID, lang, file, (data) => this.setState(data))
            const downloadUrl = uploadResult.url || uploadResult
            const storagePath = uploadResult.storagePath || `procedures_translations/${procedureID}/${lang}/${file.name}`
            const fileName = storagePath.split('/').pop()
            
            const fileInfo = {
                fileType: fileTypeForTmp,
                procedureId: procedureID,
                lang,
                storagePath,
                downloadUrl,
                fileName
            }
            
            await addFileToTmp(fileInfo)
            
            const updatedTranslationsByLang = { ...this.state.translationsByLang }
            if (!updatedTranslationsByLang[lang]) {
                updatedTranslationsByLang[lang] = { enabled: true }
            }
            updatedTranslationsByLang[lang][fileType] = downloadUrl
            
            const updatedUploadingFiles = { ...this.state.uploadingFiles }
            delete updatedUploadingFiles[uploadKey]
            
            this.setState({ 
                translationsByLang: updatedTranslationsByLang, 
                uploadingFiles: updatedUploadingFiles
            })
        } catch (error) {
            console.error(`Error al subir traducción ${lang} ${fileType}:`, error)
            const errorMessage = `Error al subir el archivo. Por favor, intenta nuevamente.`
            const translationErrorKey = `translation_${lang}`
            const updatedErrors = { ...this.state.errors }
            if (!updatedErrors[translationErrorKey]) {
                updatedErrors[translationErrorKey] = {}
            }
            updatedErrors[translationErrorKey][fileType] = errorMessage
            
            const updatedUploadingFiles = { ...this.state.uploadingFiles }
            delete updatedUploadingFiles[uploadKey]
            
            this.setState({ errors: updatedErrors, uploadingFiles: updatedUploadingFiles })
        }
    }

    handleTranslationTimeChange = (lang, index, name, value) => {
        const translationsByLang = { ...this.state.translationsByLang }
        if (!translationsByLang[lang]) {
            translationsByLang[lang] = { enabled: true, times: [] }
        }
        if (!translationsByLang[lang].times) {
            translationsByLang[lang].times = this.state.procedure.times.map(t => ({ time: t.time, name: t.name || "" }))
        }
        
        const baseTime = this.state.procedure.times[index]
        if (baseTime) {
            let translationTime = translationsByLang[lang].times.find(t => t.time === baseTime.time)
            if (!translationTime) {
                translationTime = { time: baseTime.time, name: baseTime.name || "" }
                translationsByLang[lang].times[index] = translationTime
            }
            translationTime[name] = value
        }
        
        this.setState({ translationsByLang })
    }

    handleTranslationEnabledChange = (lang, enabled) => {
        const translationsByLang = { ...this.state.translationsByLang }
        if (!translationsByLang[lang]) {
            translationsByLang[lang] = {}
        }
        translationsByLang[lang].enabled = enabled
        this.setState({ translationsByLang })
    }


    renderContentSection = (lang = DEFAULT_LANGUAGE, isTranslation = false) => {
        const { procedure, translationsByLang, errors } = this.state
        const translation = isTranslation ? translationsByLang[lang] : null
        const translationErrors = isTranslation && errors[`translation_${lang}`] ? errors[`translation_${lang}`] : {}
        const timeErrors = isTranslation ? (translationErrors.timeErrors || {}) : (errors.timeErrors || {})
        
        const getValue = (field) => {
            if (isTranslation && translation) return translation[field] || ""
            return procedure[field] || ""
        }
        
        const handleFileChange = (event) => {
            if (isTranslation) {
                this.handleTranslationFileChange(lang, event.target.name, event)
            } else {
                this.handleBaseFileChange(event)
            }
        }
        
        const timesForMarkers = procedure.times ? procedure.times.map((time, index) => {
            if (isTranslation && translation && translation.times) {
                const translationTime = translation.times.find(t => t.time === time.time) || translation.times[index]
                return {
                    ...time,
                    translatedName: translationTime ? translationTime.name : ""
                }
            }
            return time
        }) : []
        
        return (
            <>
                <VideosSection
                    demo={getValue("demo")}
                    video={getValue("video")}
                    onDemoChange={handleFileChange}
                    onVideoChange={handleFileChange}
                    demoError={isTranslation ? translationErrors.demo : errors.demo}
                    videoError={isTranslation ? translationErrors.video : errors.video}
                    lang={lang}
                />
                <MarkersSection
                    times={timesForMarkers}
                    onTimeChange={(index, name, value) => {
                        if (isTranslation) {
                            this.handleTranslationTimeChange(lang, index, name, value)
                        } else {
                            const event = { target: { name, value, id: index } }
                            this.handleTimeChange(event)
                        }
                    }}
                    onAddTime={this.addTime}
                    onDeleteTime={this.deleteTime}
                    timeErrors={timeErrors}
                    isTranslation={isTranslation}
                    lang={lang}
                />
            </>
        )
    }

    renderTextSection = (lang = DEFAULT_LANGUAGE, isTranslation = false) => {
        const { procedure, translationsByLang, errors } = this.state
        const translation = isTranslation ? translationsByLang[lang] : null
        const translationErrors = isTranslation && errors[`translation_${lang}`] ? errors[`translation_${lang}`] : {}
        
        const getValue = (field) => {
            if (isTranslation && translation) return translation[field] || ""
            return procedure[field] || ""
        }
        
        const handleInputChange = (event) => {
            if (isTranslation) {
                this.handleTranslationInputChange(lang, event.target.name, event.target.value)
            } else {
                this.handleInputChange(event)
            }
        }
        
        const handleFileChange = (event) => {
            if (isTranslation) {
                this.handleTranslationFileChange(lang, event.target.name, event)
            } else {
                this.handleBaseFileChange(event)
            }
        }
        
        return (
            <>
                <TitleDescriptionSection
                    name={getValue("name")}
                    detail={getValue("detail")}
                    onNameChange={handleInputChange}
                    onDetailChange={handleInputChange}
                    nameError={isTranslation ? translationErrors.name : errors.name}
                    detailError={isTranslation ? translationErrors.detail : errors.detail}
                    lang={lang}
                />
                <GuideSection
                    fascicle={getValue("fascicle")}
                    onFileChange={handleFileChange}
                    error={isTranslation ? translationErrors.fascicle : errors.fascicle}
                    lang={lang}
                />
                <StatusSection
                    enabled={isTranslation ? (translation ? translation.enabled : false) : true}
                    onEnabledChange={(enabled) => {
                        if (isTranslation) {
                            this.handleTranslationEnabledChange(lang, enabled)
                        }
                    }}
                    lang={lang}
                    show={isTranslation}
                />
            </>
        )
    }

    render() {
        const state = this.state
        const { errors, procedure, translationLanguages, activeLanguage } = state
        const hasTranslations = translationLanguages.length > 1
        
        const languageOptions = SUPPORTED_LANGUAGES.map(lang => ({
            value: lang,
            label: `${LANGUAGE_NAMES[lang]}`,
            isDisabled: lang === DEFAULT_LANGUAGE
        }))
        
        const selectedLanguageOptions = translationLanguages.map(lang => ({
            value: lang,
            label: `${LANGUAGE_NAMES[lang]}`,
            isDisabled: lang === DEFAULT_LANGUAGE
        }))
        
        return (
            <Form onSubmit={this.handleFormSubmit} >
                <div className="content-wrapper p-5">
                    <div className="row">
                        <div className="col-md-12">
                            <h1 className="mb-0">Cirugías</h1>
                            <h3 className="mb-5">{state.editing ? "Editar cirugía" : "Nueva cirugía"}</h3>
                            
                            {errors._general && (
                                <div className="row justify-content-center mb-3">
                                    <div className="col-md-10">
                                        <Alert variant="danger">{errors._general}</Alert>
                                    </div>
                                </div>
                            )}
                            
                            <div className="row justify-content-center mb-4">
                                <div className="col-md-10">
                                    <h4>Información general de la cirugía</h4>
                                    <div className="form-container">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>Nombre</label>
                                                    <input 
                                                        name="name" 
                                                        onChange={this.handleInputChange} 
                                                        value={procedure.name} 
                                                        type="text" 
                                                        className="form-control" 
                                                    />
                                                    <Alert show={!!errors.name} variant="danger">{errors.name}</Alert>
                                                </div>
                                                <div className="form-group">
                                                    <label>Tipo de usuario</label>
                                                    <select name="type" onChange={this.handleInputChange} value={procedure.type} className="form-control">
                                                        {CXVET_VIDEO_TYPES.map(type => <option key={type} value={type}> {type} </option>)}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <MediaUpload
                                                    label="Imagen previa"
                                                    name="preview"
                                                    value={procedure.preview}
                                                    accept={ACCEPTED_IMAGES}
                                                    onChange={this.handleBaseFileChange}
                                                    error={errors.preview}
                                                    buttonPosition="right"
                                                    maxHeight="100px"
                                                    helpText="La imagen debe tener dimensiones mínimas de 1090px x 720px"
                                                />
                                            </div>
                                        </div>
                                            <div className="form-group">
                                                <label>Especie</label>
                                                <select name="kynd" onChange={this.handleInputChange} value={procedure.kynd} className="form-control">
                                                    <option key="0" value=""> Seleccionar </option>
                                                    {SPECIES_TYPES.map(type => <option key={type} value={type}> {type} </option>)}
                                                </select>
                                                <Alert show={!!errors.kynd} variant="danger">{errors.kynd}</Alert>
                                            </div>
                                            <div className="form-group">
                                                <label>Etiquetas</label>
                                                <div className="d-block">
                                                    {this.state.tags.map(tag =>
                                                        <div key={tag.id} className="form-check form-check-inline">
                                                            <input 
                                                                name={tag.id} 
                                                                checked={procedure.tags[tag.id]} 
                                                                onChange={this.handleInputChange} 
                                                                type="checkbox" 
                                                                className="form-check-input" 
                                                            />
                                                            <label className="form-check-label">{tag.name}</label>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="form-group">
                                                <label>Meta</label>
                                                <input 
                                                    name="meta" 
                                                    onChange={this.handleInputChange} 
                                                    value={procedure.meta} 
                                                    type="text" 
                                                    className="form-control" 
                                                    placeholder="sinonimo1, sinonimo2, sinonimo3" 
                                                />
                                                <Alert show={!!errors.meta} variant="danger">{errors.meta}</Alert>
                                            </div>
                                            <div className="form-group">
                                                <label>Idiomas</label>
                                                <Select
                                                    isMulti
                                                    options={languageOptions}
                                                    value={selectedLanguageOptions}
                                                    onChange={this.handleLanguageSelectorChange}
                                                    isOptionDisabled={(option) => option.isDisabled}
                                                    placeholder="Selecciona idiomas..."
                                                />
                                                <small className="form-text text-muted">
                                                    Selecciona los idiomas para los que deseas crear traducciones. El español no puede ser eliminado.
                                                </small>
                                            </div>
                                    </div>
                                </div>
                            </div>
                            
                            <div className="row justify-content-center mb-4">
                                <div className="col-md-10">
                                    <h4>Contenido de la cirugía</h4>
                                    {hasTranslations ? (
                                        <Tabs 
                                            activeKey={activeLanguage} 
                                            onSelect={(k) => this.setState({ activeLanguage: k })}
                                            id="procedure-translations-tabs"
                                        >
                                            <Tab eventKey={DEFAULT_LANGUAGE} title={`${LANGUAGE_NAMES[DEFAULT_LANGUAGE]}`}>
                                                <div className="form-container mt-3">
                                                    <div className="row">
                                                        <div className="col-lg-6">
                                                            {this.renderTextSection()}
                                                        </div>
                                                        <div className="col-lg-6">
                                                            {this.renderContentSection()}
                                                        </div>
                                                    </div>
                                                </div>
                                            </Tab>
                                            {translationLanguages.filter(lang => lang !== DEFAULT_LANGUAGE).map(lang => (
                                                <Tab key={lang} eventKey={lang} title={LANGUAGE_NAMES[lang]}>
                                                    <div className="form-container mt-3">
                                                        <div className="row">
                                                            <div className="col-lg-6">
                                                                {this.renderTextSection(lang, true)}
                                                            </div>
                                                            <div className="col-lg-6">
                                                                {this.renderContentSection(lang, true)}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Tab>
                                            ))}
                                        </Tabs>
                                    ) : (
                                        <div className="form-container">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    {this.renderTextSection()}
                                                </div>
                                                <div className="col-md-6">
                                                    {this.renderContentSection()}
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                            
                            <div className="btn-row" >
                                {state.editing && <button type="button" onClick={() => this.setState({ deleteModalShow: true })} className="btn btn-primary">Eliminar</button>}
                                <button type="button" className="btn btn-primary" onClick={this.props.history.goBack}>Cancelar</button>
                                <button type="submit" className="btn btn-primary" >Guardar</button>
                            </div>
                        </div>
                    </div>
                </div>

                <DeleteAlertCompoment show={state.deleteModalShow} onHide={() => this.setState({ deleteModalShow: false })} deleteElement={this.deleteProcedure} />
                <UploadFileAlertComponent show={state.fileModalShow} onHide={() => this.setState({ fileModalShow: false })} file={state.fileStatus} />
            </Form>
        );
    }
}
ProcedureFormComponent.contextType = CurrentUser;
export default ProcedureFormComponent;